/**
 * Proxy new class instance
 */
export default class ControllerProxy {
	constructor(
		// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
		components: any,
		// components: Record<string, (elem: HTMLElement) => void>,
		componentName: string,
		element: HTMLElement,
	) {
		if (componentName && components && typeof components[componentName] === 'function') {
			return new components[componentName](element);
		} else {
			console.warn('Component not found', [componentName, components, element]);
		}
	}
}
